import { enableProdMode, CSP_NONCE } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements } from "@nackle/briks-platform-components/dist/loader";

export function getCspNonce(): string | null {
  const meta = document.querySelector('meta[name="csp-nonce"]');
  return meta?.getAttribute('content') || null;
}
 
const providers = [
  { provide: CSP_NONCE, useFactory: getCspNonce }
];

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic(providers).bootstrapModule(AppModule)
  .catch(err => console.error(err));

defineCustomElements(window);
